import { Component } from "@angular/core";


@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss']
})

export class PrivacyPolicyComponent{
    public date:string = new Date().toLocaleDateString('en-GB',{
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });


    constructor(){}
}